module.exports = __webpack_public_path__ + "img/20191015165330360截图20191015155612131.79e7caa0.jpg";